import { lighten, useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { TnAClientPresenceAndLeavesSummaryDTO } from "src/models/tna-client-presence-and-leaves-summary/tna-client-presence-and-leaves-summary-dto";
import { MultipleUserIcon } from "../../../../assets/icons";
import IconAndTitleContainer from "../../reusable-widget-link-components/IconAndTitleContainer/IconAndTitleContainer";

const MyClientTeamPresenceAndLeavesDashboardLink = ({
  customSummary,
  loading,
}: {
  customSummary: TnAClientPresenceAndLeavesSummaryDTO;
  loading: boolean;
}) => {
  const theme = useTheme();
  const tRP = "components.custom_widget_links.my_client_team_presence_and_leaves";
  const { t } = useTranslation();

  return (
    <IconAndTitleContainer
      title={`${t(`${tRP}.timesheets`)}`}
      titleStyle={{ color: lighten(theme.palette.primary.main, 0.2) }}
      description={`${customSummary.employees} employee(s)`}
      Icon={MultipleUserIcon}
      IconStyle={{ color: lighten(theme.palette.primary.main, 0.2), width: "50px" }}
      loading={loading}
    />
  );
};

export default MyClientTeamPresenceAndLeavesDashboardLink;
